<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <form v-on:submit.prevent="changePassword">
        <h3 class="mt0">{{'Change Password'|translate}}</h3>
        <div class="row mt20">
          <div class="col-md-4 mb20">
            <label class="mt20">{{'New password'|translate}}:</label>
            <input
              type="password"
              v-model="new_password"
              required
              ref="new_password"
              :placeholder="'New password'|translate"
              class="form-control"
            />
            <label class="mt20">{{'Confirm New password'|translate}}:</label>
            <input
              type="password"
              v-model="new_confirm_password"
              required
              ref="new_confirm_password"
              :placeholder="'Confirm New password'|translate"
              class="form-control"
            />
            <button class="btn btn-info mt20" type="submit" :disabled="updating">
              <i v-if="updating" class="fas fa-spinner fa-spin"></i> CẬP NHẬT
            </button>
          </div>
        </div>
      </form>
    </div>
    <!-- end pd20 -->
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";

export default {
  name: "ChangePassword",
  components: {
    MyHeader
  },
  data() {
    return {
      updating: false,
      new_password: "",
      new_confirm_password: ""
    };
  },
  methods: {
    changePassword() {
      if (this.new_password != this.new_confirm_password) {
        return this.$alertify.alertWithTitle(
          this.$t("Confirm"),
          this.$t("Confirm new password does not match new password")
        );
      }
      this.updating = true;
      Utils.request(this, true)
        .post(`/changePassword/`, { new_password: this.new_password })
        .then(response => {
          this.updating = false;
          let data = response.data;
          if (data.status === "ok") {
            this.$alertify.success(this.$t("Change Password sucessfully"));
            this.new_password = "";
            this.new_confirm_password = "";
          }
        })
        .catch(error => {
          Utils.showErrorMessage(this, error.response);
        });
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/Profile/ChangePassword.vue